// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, get, post } from "@insite/client-framework/Services/ApiService";

const auth0Url = "/api/auth0";
export const AUTH0_CHANGE_EMAIL_EXTERNAL_REDIRECT = `${auth0Url}/change-username`;

export interface VerifyChangeEmailApiParameter extends ApiParameter {
    idToken?: string;
    state?: string;
}

export interface ChangeEmailApiParameter extends VerifyChangeEmailApiParameter {
    newEmail: string;
}

export interface ChangePasswordModel {
    success?: boolean;
    /**
     * HTML Text, so it needs parse
     */
    message?: string;
}

export interface VerifyChangeEmailModel {
    valid: boolean;
}

export interface ChangeEmailModel {
    success: boolean;
}

export function sendAuth0ChangePassword() {
    return post<ChangePasswordModel>(`${auth0Url}/change-password`);
}

export function sendVerifyChangeEmail(parameter: VerifyChangeEmailApiParameter) {
    return post<VerifyChangeEmailApiParameter, VerifyChangeEmailModel>(`${auth0Url}/change-username/verify`, parameter);
}

export function sendChangeEmail(parameter: ChangeEmailApiParameter) {
    return post<ChangeEmailApiParameter, ChangeEmailModel>(`${auth0Url}/change-username`, parameter);
}
